import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

interface Vars {
    id: number;
    backup_ids: number[];
}

export function useDeleteBackupMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, backup_ids }: Vars) =>
            Endpoints.v1.Backups.deleteBackup(id, { backup_ids }),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['api.v1.backups.list', variables.id] });
            notifications.show({
                title: t('backup.deletedTitle'),
                message:
                    variables.backup_ids.length > 1
                        ? t('backup.deletedMessageMany', { count: variables.backup_ids.length })
                        : t('backup.deletedMessageOne'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('backup.deleteFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
